define('common/ko/fn/mapToModels',[
    'underscore',
    'knockout',
    'common/utils/optimisedMapper'
], function(_, ko, optimisedMapper) {

    /**
     * @name ModelConstructor
     * @function
     * @param {Object} initialData
     * @param {Observable<Object>} observableData
     */

    /**
     * Use this when mapping observable indexed model data to instances
     *
     * An enhancement of optimisedMapper to provide a subscribable source
     * of the raw model data so that changes can be notified to the instance.
     *
     * @param {String} key
     * @param {Function} ModelConstructor
     *
     * @return {PureComputed}
     */
    ko.subscribable.fn.mapToModels = function(key, ModelConstructor) {

        var items = this;

        var mapper = optimisedMapper(
            function(item) {
                return new ModelConstructor( item, items.property(item[key]) );
            },
            function(item) {
                return item[key];
            },
            function() {
                return 0;
            }
        );

        return items.pipe(mapper);

    };

});

